import React, { Suspense, lazy } from 'react';
import { motion } from 'framer-motion';
import { WeddingBandsDecor } from '../WeddingBandsDecor.jsx';

// Lazy-loaded — pulls in Firebase, so keep it off the initial bundle.
const RSVPForm = lazy(() =>
  import('../forms/RSVPForm.jsx').then((m) => ({ default: m.RSVPForm })),
);

const LazyFallback = () => (
  <div className="w-full flex justify-center py-16">
    <div className="w-10 h-10 border-4 border-purple-300 border-t-transparent rounded-full animate-spin" aria-label="Loading" />
  </div>
);

export function RSVPScreen({ isDarkMode, gameState, showCelebration, onSuccess, onNavigate }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.6, ease: [0.25, 1, 0.5, 1] }}
      className={`fixed inset-0 w-screen h-screen z-50 overflow-y-auto px-4 pt-28 pb-12 md:py-8 flex flex-col items-center justify-start md:justify-center transition-colors duration-700 ${
        isDarkMode
          ? 'bg-slate-950 text-white'
          : 'bg-gradient-to-br from-slate-50 via-purple-50/40 to-pink-50/40 text-slate-900'
      }`}
    >
      <WeddingBandsDecor isDarkMode={isDarkMode} />

      <motion.div
        initial={{ opacity: 0, scale: 0.95, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        className="relative z-10 w-full max-w-3xl flex flex-col items-center"
      >
        <div className="w-full max-w-2xl">
          <Suspense fallback={<LazyFallback />}>
            <RSVPForm
              mistakes={gameState.mistakes}
              onSuccess={onSuccess}
              onNavigate={onNavigate}
              gameStatus={gameState.status}
              justFinished={showCelebration}
            />
          </Suspense>
        </div>
      </motion.div>
    </motion.div>
  );
}
